// ReceiptUploadNote.jsx — aviso sobre subir el comprobante para registrar la donación.

import React from 'react'

function ReceiptUploadNote() {
  return (
    <div className="card" style={{ padding: 24, fontSize: 12, color: "var(--fg-dim)", lineHeight: 1.55 }}>
      Sube el comprobante de transferencia en el formulario para que tu donación quede registrada
      y recibas el comprobante de donación en tu correo.
    </div>
  );
}

export { ReceiptUploadNote };
